import React from "react";

type Props = {
  showGapHeader: boolean;
  showLackOfTypesHeader: boolean;
};

const EvidenceGapHeader: React.FC<Props> = (props) => {
  return (
    <div className="flex justify-center mt-3 -mb-1">
      <div className="relative flex max-w-app-column w-full pl-safe-area-l pr-safe-area-r justify-center">
        <div className="relative py-2 px-3 w-full bg-amber-100 rounded shadow-[0px_4px_12px_0px_rgba(0,0,0,0.08)] outline outline-1 outline-offset-[-1px] outline-orange-300 overflow-hidden">
          <div className=" text-neutral-800 text-acc-13px font-acc-500 leading-tight">
            <div className="flex flex-col gap-0.5">
              {props.showGapHeader && (
                <div>{"• You have a gap larger than 90 days within your selected evidences"}</div>
              )}
              {props.showLackOfTypesHeader && (
                <div>{"• There are fewer than 2 Activity Types in the evidence list"}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvidenceGapHeader;
